<template>
    <vs-popup :title="title" :active.sync="popupOpen">
        <div class="mb-4" v-if="info.success !== null && info.success !== undefined && info.errors_qty !== null && info.errors_qty !== undefined">
            Всего платежей в файле: {{Number(info.success) + Number(info.errors_qty)}}
        </div>
        <h5 class="mb-4 flex items-center" v-if="info.success !== null && info.success !== undefined">
            <feather-icon icon="CheckCircleIcon" class="mr-4" svg-classes="text-success"/>
            Импортировано: {{Number(info.success)}} платежей на сумму {{Number(info.total_sum).toFixed(2)}}руб.
        </h5>
        <h5 class="mb-4 flex items-center" v-if="Array.isArray(info.errors)">
            <feather-icon icon="AlertTriangleIcon" class="mr-4" svg-classes="text-danger"/>
            Ошибок: {{info.errors ? info.errors.length : 0}}
        </h5>
        <table class="w-full" v-if="Array.isArray(info.errors) && info.errors.length">
            <tbody>
            <tr  v-for="(error, index) in info.errors" :key="`key-${index}`">
                <td>{{error}}</td>
            </tr>
            </tbody>
        </table>
        <h5 class="mb-4 flex items-center" v-if="!Array.isArray(info.errors)">
            Ошибок: {{info.errors}}
        </h5>
    </vs-popup>
</template>

<script>
    export default {
        name: "SberbankImportPopup",
        props: {
            title: {
                default: null
            },
            isOpen: {
                default: false,
            },
            info: {
                default: null,
            }
        },
        computed: {
            popupOpen: {
                get(){
                    return this.isOpen;
                },
                set(value){
                    this.$emit('openChanged', value);
                }
            }
        }
    }
</script>